import { render, staticRenderFns } from "./UnknownMessageView.vue?vue&type=template&id=386f642a&"
import script from "./UnknownMessageView.vue?vue&type=script&lang=js&"
export * from "./UnknownMessageView.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/workspace/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('386f642a')) {
      api.createRecord('386f642a', component.options)
    } else {
      api.reload('386f642a', component.options)
    }
    module.hot.accept("./UnknownMessageView.vue?vue&type=template&id=386f642a&", function () {
      api.rerender('386f642a', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "public/js/src/app/components/pay-invoice/UnknownMessageView.vue"
export default component.exports